import React from 'react';
import { withStyles } from '@material-ui/styles';

import { Link as RouterLink } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import PrintIcon from '@material-ui/icons/Print';
import {
    Grid,
    Paper,
    FormControl,
    TextField,
    Button,
    Divider,
    FormLabel,
    IconButton,
    InputAdornment,
    ListItemText,
    FormControlLabel,
    Radio,
    TableContainer,
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
    Typography,
    MenuItem
} from '@material-ui/core';

import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import DescriptionIcon from '@material-ui/icons/Description';
import SendIcon from '@material-ui/icons/Send';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import TabControl from './TabControl';

import { Dialog } from 'components';
import { TotalLate, TotalBills, Pagination, Field, Bill, Creation } from './components';
import env from 'common/env';
import banks from 'common/banks';
import UserProfile from 'UserProfile';
import { payBill } from './http';

const styles = theme => ({
    root: {
        padding: theme.spacing(4),
        flexGrow: 1
    },
    paperContent: {
        padding: theme.spacing(3)
    },
    labelFilter: {
        color: '#3f51b5',
        marginBottom: 15
    },
    labelFilterRadio: {
        color: '#3f51b5',
        marginBottom: 5
    }
});

const columns = [
    {
        id: 'date',
        label: 'Date',
        minWidth: '10%',
        align: 'left'
    },
    {
        id: 'numero',
        label: 'N°',
        minWidth: '10%',
        align: 'left'
    },
    {
        id: 'raisonSociale',
        label: 'Raison sociale',
        minWidth: '20%',
        align: 'left'
    },
    {
        id: 'facture',
        label: 'Facture',
        minWidth: '20%',
        align: 'left'
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: '10%',
        align: 'center'
    },
    {
        id: 'mail',
        label: 'Mail',
        minWidth: '20%',
        align: 'center'
    },
    {
        id: 'montant',
        label: 'Montant',
        minWidth: '10%',
        align: 'left'
    }
];

class DomainBills extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            isSubmited: Boolean(
                this.props.match.params.start && this.props.match.params.start != 'creation'
            ),
            searchValue: '',
            cat: this.props.match.params.start == 'creation' ? 'creation' : 'bill',
            start: this.props.match.params.start || '',
            end: this.props.match.params.end || '',
            approvedDate: {
                start:
                    this.props.match.params.start && this.props.match.params.start != 'creation'
                        ? new Date(this.props.match.params.start)
                        : '',
                end:
                    this.props.match.params.start && this.props.match.params.start != 'creation'
                        ? new Date(this.props.match.params.end)
                        : ''
            },
            disableSearch: !Boolean(
                this.props.match.params.start && this.props.match.params.start != 'creation'
            ),
            list: [],
            montant: 0,
            number: 0,
            options: {
                //weekday: 'numeric',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            },
            page: 1,
            numberOfPages: 0,
            openBill: false,
            bill: null,

            // For payment dialog
            selectedBillId: null,
            openPayBill: false,
            processing: false,
            currencies: [],
            banque: '',
            cheque: '',
            moyen: '',
            regexp: /^[0-9\b]+$/,
            billEvent: null
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (
            prevProps.match.params.start != this.props.match.params.start ||
            prevProps.match.params.end != this.props.match.params.end ||
            prevProps.match.params.type != this.props.match.params.type
        ) {
            this.setState({
                start: this.props.match.params.start || '',
                end: this.props.match.params.end || '',
                approvedDate: {
                    start:
                        this.props.match.params.start && this.props.match.params.start != 'creation'
                            ? new Date(this.props.match.params.start)
                            : '',
                    end: this.props.match.params.end ? new Date(this.props.match.params.end) : ''
                },
                cat: this.props.match.params.start == 'creation' ? 'creation' : 'bill',
                disableSearch: !Boolean(
                    this.props.match.params.start && this.props.match.params.start != 'creation'
                ),
                isSubmited: Boolean(
                    this.props.match.params.start && this.props.match.params.start != 'creation'
                ),
                list: []
            });
        }

        if (this.state.isSubmited) {
            this.getData();
        }

        (this.state.searchValue != prevState.searchValue || this.state.page != prevState.page) &&
            this.getData();

        if (this.state.selectedBillId && this.state.selectedBillId !== prevState.selectedBillId) {
            this.getBillEvent();
        }

        if (!this.state.selectedBillId && this.state.selectedBillId !== prevState.selectedBillId) {
            this.getData();
        }
    };

    componentDidMount = () => {
        this.state.isSubmited && this.getData();
        this.getMeansOfPayment();
    };

    getBillEvent = () => {
        this.state.selectedBillId &&
            fetch(`${env}/domaine/see-bill-event/${this.state.selectedBillId}`)
                .then(res => (res.ok ? res.json() : false))
                .then(data => this.setState({ billEvent: data }));
    };

    getMeansOfPayment = () => {
        fetch(`${env}/regie/get-means-of-payment`)
            .then(res => (res.ok ? res.json() : false))
            .then(data => this.setState({ currencies: data }));
    };

    getData = () => {
        this.setState({
            isSubmited: false
        });

        const formData = new FormData();
        formData.append('page', this.state.page);
        formData.append('start', this.state.start);
        formData.append('end', this.state.end);
        formData.append('search', this.state.searchValue);

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domaine/get-bill-event`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data
                });
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    sendData = (numFacture, moyen, banque = false, cheque = false) => {
        const formData = new FormData();
        formData.append('moyen', moyen);
        banque && formData.append('banque', banque);
        cheque && formData.append('cheque', cheque);

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/regie/update-bill/${numFacture}`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                alert('Facture N°' + numFacture + ' réglée avec succès.');
                this.setState({
                    openBill: false,
                    bill: null
                });
                this.getData();
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    handleSearch = ({ target: { value } }) => {
        this.setState({
            searchValue: value,
            page: 1
        });
    };

    clearSearch = () => {
        this.setState({
            searchValue: '',
            page: 1
        });
    };

    handlePagination = selectedPage => {
        this.setState({
            page: selectedPage
        });
    };

    handleDate = ({ target: { name, value } }) => {
        this.setState({
            [name]: value
        });
    };

    handleForm = () => {
        const { start, end, approvedDate, type } = this.state;

        if (start == '') {
            alert('Veuillez saisir une date de début');
            return;
        }

        if (end == '') {
            alert('Veuillez saisir une date de fin');
            return;
        }

        const _start = new Date(start);
        const _end = new Date(end);

        if (_start.getTime() > _end.getTime()) {
            let inverse = window.confirm(
                'La date de début est supérieur à la date de fin\nInverser les dates ?'
            );
            inverse &&
                this.setState({
                    start: end,
                    end: start
                });
            return;
        }

        this.setState({
            approvedDate: {
                start: _start,
                end: _end
            }
        });

        this.props.history.push('/domain-bills/' + start + '/' + end + '/' + (type || 'all'));
    };

    handlePagination = selectedPage => {
        this.setState({
            page: selectedPage
        });
    };

    formatCash = value => {
        let montants = parseFloat(value)
            .toString()
            .split('.');
        return (
            montants[0] +
            ', ' +
            (montants[1] ? (montants[1] + '00')[0] + (montants[1] + '00')[1] : '00') +
            ' €'
        );
    };

    sendMissedData = (data, marchand_id, numFacture) => {
        const confirmation = window.confirm(
            "Cette action mettra à jour l'adresse mail du commerçant et l'enverra sur celle-ci.\nContinuer l'envoi ?"
        );
        let mailMarchand = data;

        if (confirmation) {
            const formData = new FormData();
            formData.append('field', 'mailMarchand');
            formData.append('data', data);

            fetch(
                `https://www.${
                    window.location.hostname.split('.')[1]
                        ? window.location.hostname.split('.')[0] === 'www'
                            ? window.location.hostname.split('.')[1]
                            : window.location.hostname.split('.')[0]
                        : 'dev'
                }.api.digitmarche.fr/api/merchant/update-fields-missed/${marchand_id}`,
                {
                    method: 'POST',
                    body: formData
                }
            )
                .then(res => res.json())
                .then(data => {
                    if (data) {
                        alert('Mise à jour effectuée');
                        this.getData();
                        this.sendByMail(numFacture, mailMarchand);
                    }
                })
                .catch(console.log);
        }
    };

    getPdf = numFacture => {
        window.open(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domaine/get-bill-event/${numFacture}`,
            '_blank'
        );
    };

    sendByMail = (numFacture, mail) => {
        const formData = new FormData();
        formData.append('mail', mail);

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domaine/send-bill-by-mail/${numFacture}`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                if (data.sent) {
                    alert('Facture envoyée avec succès.');
                    this.getData();
                } else {
                    alert("Echec d'envoi de la facture.");
                    this.getData();
                }
            })
            .catch(
                error => {
                    console.error(error);
                    alert("Echec d'envoi de la facture.");
                    this.getData();
                } // Handle the error response object
            );
    };

    handleCash = numFacture => {
        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domain/get-bill/${numFacture}`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    bill: data,
                    openBill: true
                });
            })
            .catch(
                error => {
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    closeBill = () => {
        this.setState({
            bill: null,
            openBill: false
        });
    };

    printThermalBill = numFacture => {
        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domaine/get-bill-for-thermal-printer/${numFacture}`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.text() : false;
            })
            .then(data => {
                window.frames['frame-for-print'].document.body.innerHTML = data;
                window.frames['frame-for-print'].window.focus();
                window.frames['frame-for-print'].window.print();
            })
            .catch(
                error => {
                    console.error(error);
                    alert("Echec de l'impression.");
                } // Handle the error response object
            );
    };

    payBill = (billId = null) => {
        this.setState({
            selectedBillId: billId,
            openPayBill: Boolean(billId),
            billEvent: billId ? null : this.state.billEvent
        });

        if (billId === null) {
            this.handleMoyen({ target: { value: '' } });
        }
    };

    handleBanque = event => {
        this.setState({
            banque: event.target.value
        });
    };

    handleCheque = ({ target: { value } }) => {
        (value === '' || this.state.regexp.test(value)) &&
            this.setState({
                cheque: value.replace(/\s/g, '').slice(0, 7)
            });
    };

    handleMoyen = ({ target: { value } }) => {
        this.setState({
            moyen: value,
            cheque: '',
            banque: ''
        });
    };

    payThatFuckingBill = () => {
        const { moyen, cheque, banque, selectedBillId, billEvent } = this.state;

        if (moyen === '') {
            alert('Veuillez sélectionner un moyen de paiement');
            return;
        }

        if (moyen === 2) {
            if (!banque || banque.length == 0 || !banque.replace(/\s/g, '').length) {
                alert('Veuillez saisir une banque');
                return;
            }

            if (!cheque || cheque.length == 0 || !cheque.replace(/\s/g, '').length) {
                alert('Veuillez saisir un numéro de chèque');
                return;
            }

            if (cheque.length != 7) {
                alert('Veuillez saisir un numéro de chèque valide (7 numéros obligatoires)');
                return;
            }
        }

        if (selectedBillId) {
            this.setState({ processing: true });

            payBill(this.state.selectedBillId, moyen, banque, cheque)
                .then(() => {
                    if (UserProfile.getConfig()?.auto_print_bill) {
                        window.location.replace(
                            `/print-bill?back=${window.location.pathname}&num_facture=${
                                billEvent?.numFacture
                            }&token=${UserProfile.getToken()}&impression_en_cours.png`
                        );
                    }

                    alert(`Facture ${billEvent?.numFacture} réglée avec succés`);

                    this.payBill();
                })
                .finally(() => {
                    this.setState({ processing: false });
                });
        } else {
            alert("Echec lors de l'encaissement de la facture.");
        }
    };

    render() {
        const {
            classes,
            searchValue,
            start,
            end,
            approvedDate,
            disableSearch,
            options,
            list,
            page,
            numberOfPages,
            number,
            montant,
            openBill,
            bill,
            cat,

            // for bill ot be paid after
            openPayBill,
            processing,
            banque,
            cheque,
            moyen,
            currencies,
            billEvent
        } = this.state;

        return (
            <div className={classes.root}>
                {bill && (
                    <Bill
                        data={bill}
                        sendData={this.sendData}
                        close={this.closeBill}
                        open={openBill}
                    />
                )}

                <Dialog
                    open={openPayBill}
                    onClose={() => this.payBill()}
                    title={`Régler facture ${billEvent?.numFacture}`}
                    action={
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.payThatFuckingBill()}
                            disabled={processing}>
                            Régler
                        </Button>
                    }>
                    <Grid container direction="column" spacing={2}>
                        <Grid item style={{ marginTop: 10 }}>
                            <FormControl required component="fieldset">
                                <FormLabel color="primary">Moyen de paiement</FormLabel>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                select
                                fullWidth
                                //size="small"
                                variant="outlined"
                                value={moyen}
                                helperText={'Choisir un moyen de paiement'}
                                onChange={this.handleMoyen}>
                                {currencies.map(option => (
                                    <MenuItem key={option.id} value={option.id}>
                                        <Typography variant="body1" color="primary">
                                            {option.label}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {moyen == 2 && (
                            <React.Fragment>
                                <Grid item>
                                    <TextField
                                        select
                                        fullWidth
                                        value={banque}
                                        variant="outlined"
                                        helperText="Saisir une banque"
                                        onChange={this.handleBanque}>
                                        {banks.map(option => (
                                            <MenuItem key={option.title} value={option.title}>
                                                <Typography variant="body1" color="primary">
                                                    {option.title}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        //size="small"
                                        variant="outlined"
                                        name="cheque"
                                        helperText="Saisir un numéro de chèque"
                                        fullWidth
                                        value={cheque}
                                        onChange={this.handleCheque}
                                        placeholder="1234567"
                                    />
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </Dialog>

                <iframe
                    name="frame-for-print"
                    width="0"
                    height="0"
                    frameborder="0"
                    src="about:blank"></iframe>
                <Grid container direction="column">
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            component={RouterLink}
                            to={'/domain-bills/creation'}>
                            <EuroSymbolIcon style={{ marginRight: 7 }} /> Créer une nouvelle facture
                        </Button>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <TabControl value={cat} index={'creation'}>
                                    <Creation history={this.props.history} />
                                </TabControl>
                            </Grid>
                            <Grid item>
                                <TabControl value={cat} index={'bill'}>
                                    <Paper className={classes.paperContent}>
                                        <FormControl component="fieldset" required>
                                            <FormLabel
                                                className={classes.labelFilter}
                                                component="label">
                                                Rechercher par date
                                            </FormLabel>
                                        </FormControl>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="flex-start"
                                            alignItems="center"
                                            spacing={2}>
                                            <Grid item xs={12} md={5}>
                                                <TextField
                                                    type="date"
                                                    fullWidth
                                                    name="start"
                                                    value={start}
                                                    onChange={this.handleDate}
                                                    size="small"
                                                    variant="outlined"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={5}>
                                                <TextField
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    name="end"
                                                    value={end}
                                                    onChange={this.handleDate}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    color="primary"
                                                    onClick={this.handleForm}>
                                                    Rechercher
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </TabControl>
                            </Grid>
                            <Grid item>
                                <TabControl value={cat} index={'bill'}>
                                    <Grid container direction="row" spacing={3}>
                                        <Grid item xs={12} sm={6} md={6}>
                                            <TotalLate data={{ montant: montant }} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6}>
                                            <TotalBills data={{ number: number }} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Paper className={classes.paperContent}>
                                                <Grid
                                                    container
                                                    direction="column"
                                                    justify="center"
                                                    alignItems="stretch"
                                                    spacing={3}>
                                                    <Grid item>
                                                        <TextField
                                                            label={
                                                                !disableSearch &&
                                                                `Rechercher une facture du ${approvedDate.start.toLocaleDateString(
                                                                    'fr-FR',
                                                                    options
                                                                )} au ${approvedDate.end.toLocaleDateString(
                                                                    'fr-FR',
                                                                    options
                                                                )}`
                                                            }
                                                            type="text"
                                                            fullWidth
                                                            value={searchValue}
                                                            disabled={disableSearch}
                                                            onChange={this.handleSearch}
                                                            variant="outlined"
                                                            helperText={
                                                                !disableSearch &&
                                                                'Saisir un numéro de facture, un SIREN, une raison sociale ou une enseigne'
                                                            }
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            disabled={disableSearch}
                                                                            onClick={
                                                                                this.clearSearch
                                                                            }
                                                                            edge="end">
                                                                            <ClearIcon
                                                                                style={{
                                                                                    color: 'red'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <Divider />
                                                    </Grid>
                                                    <Grid item>
                                                        <TableContainer
                                                            className={classes.container}>
                                                            <Table
                                                                stickyHeader
                                                                aria-label="sticky table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        {columns.map(column => (
                                                                            <TableCell
                                                                                key={column.id}
                                                                                align={column.align}
                                                                                style={{
                                                                                    minWidth:
                                                                                        column.minWidth
                                                                                }}>
                                                                                {column.label}
                                                                            </TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {list.map((bill, key) => {
                                                                        return (
                                                                            <TableRow
                                                                                hover
                                                                                key={bill.numero}>
                                                                                {columns.map(
                                                                                    column => {
                                                                                        if (
                                                                                            column.id ==
                                                                                            'facture'
                                                                                        ) {
                                                                                            return (
                                                                                                <TableCell
                                                                                                    key={
                                                                                                        bill.numero
                                                                                                    }
                                                                                                    align={
                                                                                                        column.align
                                                                                                    }>
                                                                                                    <Grid
                                                                                                        container
                                                                                                        direction="row"
                                                                                                        justify="flex-start"
                                                                                                        alignItems="center">
                                                                                                        <Grid
                                                                                                            item>
                                                                                                            <IconButton
                                                                                                                onClick={() =>
                                                                                                                    isMobile
                                                                                                                        ? this.printThermalBill(
                                                                                                                              bill.numero
                                                                                                                          )
                                                                                                                        : this.getPdf(
                                                                                                                              bill.numero
                                                                                                                          )
                                                                                                                }>
                                                                                                                {isMobile ? (
                                                                                                                    <PrintIcon />
                                                                                                                ) : (
                                                                                                                    <DescriptionIcon />
                                                                                                                )}
                                                                                                            </IconButton>
                                                                                                        </Grid>
                                                                                                        <Grid
                                                                                                            item>
                                                                                                            <ListItemText
                                                                                                                primary={
                                                                                                                    bill.numero
                                                                                                                }
                                                                                                                secondary={
                                                                                                                    bill.paid ===
                                                                                                                    '1' ? (
                                                                                                                        <React.Fragment>
                                                                                                                            Réglé{' '}
                                                                                                                            <DoneIcon
                                                                                                                                style={{
                                                                                                                                    fontSize:
                                                                                                                                        'inherit',
                                                                                                                                    color:
                                                                                                                                        'green'
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        </React.Fragment>
                                                                                                                    ) : null
                                                                                                                }
                                                                                                            />
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                </TableCell>
                                                                                            );
                                                                                        }

                                                                                        if (
                                                                                            column.id ==
                                                                                            'mail'
                                                                                        ) {
                                                                                            return (
                                                                                                <TableCell
                                                                                                    key={`mail-${key}`}
                                                                                                    align={
                                                                                                        column.align
                                                                                                    }>
                                                                                                    {bill.mail ==
                                                                                                    '0' ? (
                                                                                                        <Field
                                                                                                            sendData={
                                                                                                                this
                                                                                                                    .sendMissedData
                                                                                                            }
                                                                                                            data={
                                                                                                                bill
                                                                                                            }
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <Button
                                                                                                            size="small"
                                                                                                            variant="contained"
                                                                                                            color="primary"
                                                                                                            onClick={() =>
                                                                                                                this.sendByMail(
                                                                                                                    bill.numero,
                                                                                                                    bill.mail
                                                                                                                )
                                                                                                            }>
                                                                                                            Envoyer{' '}
                                                                                                            <SendIcon
                                                                                                                style={{
                                                                                                                    marginLeft: 7
                                                                                                                }}
                                                                                                            />
                                                                                                        </Button>
                                                                                                    )}
                                                                                                </TableCell>
                                                                                            );
                                                                                        }

                                                                                        if (
                                                                                            column.id ==
                                                                                            'montant'
                                                                                        ) {
                                                                                            return (
                                                                                                <TableCell
                                                                                                    key={`amount-${key}`}
                                                                                                    align={
                                                                                                        column.align
                                                                                                    }>
                                                                                                    {
                                                                                                        bill[
                                                                                                            column
                                                                                                                .id
                                                                                                        ]
                                                                                                    }{' '}
                                                                                                    €
                                                                                                </TableCell>
                                                                                            );
                                                                                        }

                                                                                        if (
                                                                                            column.id ===
                                                                                            'action'
                                                                                        ) {
                                                                                            return (
                                                                                                <TableCell
                                                                                                    key={`action-${key}`}
                                                                                                    align={
                                                                                                        column.align
                                                                                                    }>
                                                                                                    <Button
                                                                                                        size="small"
                                                                                                        variant="contained"
                                                                                                        color="primary"
                                                                                                        disabled={
                                                                                                            bill.paid ===
                                                                                                            '1'
                                                                                                        }
                                                                                                        onClick={() =>
                                                                                                            this.payBill(
                                                                                                                bill.id
                                                                                                            )
                                                                                                        }>
                                                                                                        Encaisser
                                                                                                    </Button>
                                                                                                </TableCell>
                                                                                            );
                                                                                        }

                                                                                        return (
                                                                                            <TableCell
                                                                                                key={
                                                                                                    bill.numero
                                                                                                }
                                                                                                align={
                                                                                                    column.align
                                                                                                }>
                                                                                                {
                                                                                                    bill[
                                                                                                        column
                                                                                                            .id
                                                                                                    ]
                                                                                                }
                                                                                            </TableCell>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                    <Grid item>
                                                        <Pagination
                                                            numberOfPages={numberOfPages}
                                                            currentPage={page}
                                                            handlePagination={this.handlePagination}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </TabControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(DomainBills);
